// CMYK color type

export type CMYKColor = {
  c: number // cyan
  m: number // magenta
  y: number // yellow
  k: number // key/black
  a: number // alpha
}
